var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('heads',{attrs:{"more":_vm.showMore,"msg":_vm.title_msg}}),_c('div',{staticClass:"agreement",domProps:{"innerHTML":_vm._s(_vm.html)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }